module.exports = __webpack_public_path__ + "static/img/about_photo01.8c05c029.jpg";